<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0">
						<v-row class="d-flex justify-space-between">
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-left align-center pa-2">
									{{ $t('titles.activities') }}</v-card-title
								>
							</v-col>
							<v-col v-if="canEdit" class="d-flex justify-end align-center pa-2 pb-0 pt-0">
								<v-btn color="basicButton" @click="addActivity()">
									{{ $t('buttons.addActivity') }}
									<v-icon small class="ml-2">fas fa-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0">
								<TheTable
									:additional-filters="teacherActivitiesTable.additionalFilters"
									:default-sort="teacherActivitiesTable.defaultSort"
									:excel="false"
									:fields="teacherActivitiesTable.headers"
									:header-selection-key="'teacher-activities-headers'"
									:height="teacherActivitiesTable.height"
									:total-records="teacherActivitiesTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in teacherActivitiesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editActivity(props.item.id, true)"
									>
										<td
											v-if="teacherActivitiesTable.selectedHeaders.includes('full_name')"
											@click="editActivity(item.id)"
										>
											{{ item.teacher.full_name }}
										</td>
										<td
											v-if="teacherActivitiesTable.selectedHeaders.includes('date')"
											@click="editActivity(item.id)"
										>
											{{
												item.date != null ? item.date.split('-').reverse().join('.') + '.' : ''
											}}
										</td>
										<td
											style="text-align: right"
											v-if="teacherActivitiesTable.selectedHeaders.includes('hours')"
											@click="editActivity(item.id)"
										>
											{{ item.hours_display }}
										</td>
										<td
											v-if="teacherActivitiesTable.selectedHeaders.includes('description')"
											@click="editActivity(item.id)"
										>
											{{ item.description }}
										</td>
										<td
											v-if="teacherActivitiesTable.selectedHeaders.includes('billing')"
											@click="editActivity(item.id)"
										>
											{{ item.billing ? 'Da' : 'Ne' }}
										</td>
										<td
											v-if="teacherActivitiesTable.selectedHeaders.includes('hour_rate_type')"
											@click="editActivity(item.id)"
										>
											{{ item.hour_rate_type }}
										</td>
										<td
											style="text-align: right"
											v-if="teacherActivitiesTable.selectedHeaders.includes('hour_rate')"
											@click="editActivity(item.id)"
										>
											{{ item.hour_rate_display }}
										</td>
										<td
											style="text-align: right"
											v-if="teacherActivitiesTable.selectedHeaders.includes('amount')"
											@click="editActivity(item.id)"
										>
											{{
												// item.total ? item.total_display : null,
												item.total_display
											}}
										</td>
										<td v-if="canEdit">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														v-on="on"
														@click="deleteActivity(item.id)"
													>
														<v-icon small>fas fa-trash</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.deleteActivity') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="showModal">
			<v-col>
				<Modal :show-modal="showModal">
					<TeacherActivity
						:activityId="activityId"
						:plannedCourseId="plannedCourseId"
						:canEdit="canEdit"
						@close="closeModal"
					></TeacherActivity>
				</Modal>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import TeacherActivity from './TeacherActivity';
import Modal from '../../trinkets/Modal';

export default {
	name: 'teacherActivities',
	components: { TheTable, Modal, TeacherActivity },
	props: {
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	emits: ['reloadParticipants'],
	data: function () {
		return {
			teacherActivitiesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.teacher'),
						value: 'full_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: true },
					{
						text: this.$t('fields.hoursAmount'),
						value: 'hours',
						type: '',
						sortable: false,
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.activityDescription'),
						value: 'description',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.billing'),
						value: 'billing',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.hourRateType'),
						value: 'hour_rate_type',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.hourRate'),
						value: 'hour_rate',
						type: '',
						sortable: false,
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.amount'),
						value: 'amount',
						type: '',
						sortable: false,
						allowFilter: true,
						alignRight: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			showModal: false,
			activityId: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.teacherActivitiesTable.selectedHeaders = headers;
		},
		addActivity() {
			this.showModal = true;
		},
		editActivity(id) {
			this.activityId = id;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.activityId = 0;
		},
		deleteActivity(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					this.$APICall('delete', 'teacher-activities/' + id + '/delete', {}, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicDelete'));
							vm.reloadData(vm.teacherActivitiesTable.lastRequest);
							vm.$modalBus.$emit('reloadPlannedCourse');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		reloadData(request) {
			this.teacherActivitiesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'planned-course-teacher-activities/' + this.plannedCourseId,
				request,
				(data, success) => {
					if (success) {
						vm.teacherActivitiesTable.items = data.items;
						vm.teacherActivitiesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherActivitiesTable.height = window.innerHeight - 350 + 'px';
		},
	},
	mounted() {
		let vm = this;

		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadTeacherActivities', () => {
			vm.reloadData(vm.teacherActivitiesTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
